module.exports = __webpack_public_path__ + "static/img/ydbg7@2x.e037c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ydbg7@2x.png
// module id = HPyO
// module chunks = 1